
module.filter('eflName', function(eflNumberFilter, eflNames) {
    return function(val) {
        var efl = eflNumberFilter(val);
        return efl && eflNames[efl - 3];
    };
});